import React, { useState } from "react";

const InterviewProgressCircle = ({
  assigned,
  scheduled,
  completed,
  size = 160,
  strokeWidth = 10,
}) => {
  const [hovered, setHovered] = useState(null);

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const total = Math.max(assigned || 0, 0);
  const scheduledPct = total ? (scheduled / total) * 100 : 0;
  const completedPct = total ? (completed / total) * 100 : 0;

  const scheduledLength = (Math.max(scheduledPct, 0) / 100) * circumference;
  const completedLength = (Math.max(completedPct, 0) / 100) * circumference;

  const innerSize = size * 0.8;
  const centerStyle = {
    width: `${innerSize}px`,
    height: `${innerSize}px`,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "50%",
    backgroundColor: "#0048B7",
    border: "1px solid #E4E9F0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    color: "#FFFFFF",
    textAlign: "center",
    lineHeight: 1,
  };

  const containerStyle = {
    position: "relative",
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <div style={containerStyle}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        {/* Background */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#E0E0E0"
          strokeWidth={strokeWidth}
        />

        {/* ✅ Completed segment first (green) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={hovered === "completed" ? "#2ecc71" : "#4CC948"}
          strokeWidth={hovered === "completed" ? strokeWidth + 2 : strokeWidth}
          strokeDasharray={`${completedLength} ${circumference - completedLength}`}
          strokeDashoffset={0}
          strokeLinecap="butt"
          style={{ cursor: "pointer", transition: "0.3s" }}
          onMouseEnter={() => setHovered("completed")}
          onMouseLeave={() => setHovered(null)}
        />

        {/* Scheduled segment follows completed */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={hovered === "scheduled" ? "#ffb347" : "#FFC857"}
          strokeWidth={hovered === "scheduled" ? strokeWidth + 2 : strokeWidth}
          strokeDasharray={`${scheduledLength} ${circumference - scheduledLength}`}
          strokeDashoffset={-completedLength}
          strokeLinecap="butt"
          style={{ cursor: "pointer", transition: "0.3s" }}
          onMouseEnter={() => setHovered("scheduled")}
          onMouseLeave={() => setHovered(null)}
        />
      </svg>

      {/* Center content */}
      <div style={centerStyle}>
        {hovered === "completed" ? (
          <>
            <img src="/images/color-star-rating-call.svg" alt="" />
            <div style={{ fontSize: "42px", fontWeight: 700 }}>{completed}</div>
            <p style={{ fontSize: "10px" }}>Completed</p>
          </>
        ) : hovered === "scheduled" ? (
          <>
            <img src="/images/color-calendar-check.svg" alt="" />
            <div style={{ fontSize: "42px", fontWeight: 700 }}>{scheduled}</div>
            <p style={{ fontSize: "10px" }}>Scheduled</p>
          </>
        ) : (
          <>
            <img src="/images/user-add.svg" alt="" />
            <div style={{ fontSize: "42px", fontWeight: 700 }}>{total}</div>
            <p style={{ fontSize: "10px" }}>Interviews<br />Assigned</p>
          </>
        )}
      </div>
    </div>
  );
};

export default InterviewProgressCircle;
